import React from 'react';
import { useRecoilValue } from 'recoil';

import { CarrierLogoStackNames } from '@/components/modules/carrier/logo-stack-names';
import { JourneyRowTemplate } from '@/components/modules/journey/row-template';
import { JourneyTextBlock } from '@/components/modules/journey/text-block';
import { OptionBarSequence } from '@/components/modules/option/bar-sequence';
import { getOptionSequenceItems } from '@/components/modules/option/bar-sequence/utils';
import { OptionRowComponentProps, sharedOptionRowStyles } from '@/components/modules/option/row';
import { VehicleNameList } from '@/components/modules/vehicle/name-list';
import { MODE_AIR } from '@/lib/constants';
import { locationsState } from '@/state/locations';
import { formatDuration, formatFrequency } from '@/utils/format';
import { getOptionModelStopsListString, getOptionModelStopsShortString } from '@/utils/strings';
import { tv } from '@/utils/styles';

const OptionRowRail = ({ option, onClickDetails, maxDurationRatio }: OptionRowComponentProps) => {
  const locations = useRecoilValue(locationsState);
  const sequenceItems = getOptionSequenceItems({ option, locations });

  const { totalDurationSeconds, frequency } = option;

  const { base } = styles();
  const { gridBlock, bar } = sharedOptionRowStyles();
  return (
    <JourneyRowTemplate onClickDetails={onClickDetails}>
      <div className={base()}>
        <div className={gridBlock()}>
          <JourneyTextBlock
            primaryText={formatDuration(totalDurationSeconds)}
            subText={frequency ? formatFrequency(frequency) : ''}
          />
        </div>
        <div className={gridBlock()}>
          <JourneyTextBlock
            primaryText={getOptionModelStopsShortString({ option, mode: MODE_AIR })}
            subText={getOptionModelStopsListString({ option, mode: MODE_AIR, locations })}
          />
        </div>
        <div className={gridBlock()}>
          <div className={bar()}>
            <OptionBarSequence sequenceItems={sequenceItems} ratio={maxDurationRatio} />
          </div>
          <VehicleNameList vehicleIds={option.vehicleIds || []} />
        </div>
        <div className={gridBlock()}>
          <CarrierLogoStackNames carrierIds={option.carrierIds} mode={MODE_AIR} />
        </div>
      </div>
    </JourneyRowTemplate>
  );
};

const styles = tv({
  slots: {
    base: 'relative grid grid-cols-[140px_140px_1fr_240px_120px] leading-[14px]',
  },
});

export { OptionRowRail };
